import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 720.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)" >


<path d="M6950 5610 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M7093 5605 c-3 -9 -3 -18 0 -22 10 -10 37 6 37 22 0 20 -29 20 -37 0z"/>
<path d="M6750 5504 c0 -8 5 -12 10 -9 6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0
-10 -7 -10 -16z"/>
<path d="M6869 5494 c-10 -13 -10 -17 1 -24 19 -12 40 -1 40 21 0 23 -23 25
-41 3z"/>
<path d="M7021 5466 c-8 -10 -9 -16 -1 -21 13 -8 30 3 30 21 0 18 -14 18 -29
0z"/>
<path d="M6723 5394 c-33 -16 -52 -50 -36 -64 21 -20 61 -19 87 1 25 20 37 69
17 69 -5 0 -15 2 -23 5 -7 2 -27 -3 -45 -11z"/>
<path d="M6575 5389 c-4 -6 -5 -13 -2 -16 7 -7 27 6 27 18 0 12 -17 12 -25 -2z"/>
<path d="M6893 5334 c-3 -8 0 -21 6 -27 14 -14 44 2 49 27 5 22 -46 22 -55 0z"/>
<path d="M4924 5269 c-253 -133 -458 -332 -559 -544 -51 -107 -65 -161 -65
-249 0 -98 30 -168 99 -237 85 -84 139 -101 322 -107 149 -4 281 12 428 54 91
26 68 8 -31 -24 -203 -65 -426 -106 -639 -118 -296 -17 -483 79 -466 240 3 28
8 62 12 76 6 24 5 24 -10 -3 -25 -44 -45 -117 -45 -170 0 -120 75 -197 240
-249 68 -21 93 -23 260 -22 149 0 207 5 300 23 436 85 897 287 1311 575 149
103 336 265 474 408 89 93 183 208 169 208 -12 0 -80 -78 -76 -88 2 -7 -3 -10
-12 -6 -9 4 -28 -7 -50 -28 -61 -59 -110 -102 -156 -137 -25 -19 -47 -37 -50
-40 -12 -15 -249 -191 -257 -191 -5 0 -18 -8 -29 -18 -18 -17 -117 -75 -194
-113 -27 -13 -38 -15 -49 -6 -12 10 -14 9 -8 -5 9 -25 -10 -32 -23 -8 -6 11
-16 20 -23 20 -7 0 -22 11 -35 24 -16 18 -19 26 -10 30 7 3 1 4 -14 1 -31 -6
-37 9 -10 24 16 10 16 10 -1 11 -10 0 -15 5 -12 10 11 17 -19 11 -73 -15 -29
-14 -54 -25 -57 -25 -2 0 -29 -11 -59 -25 -74 -34 -259 -91 -376 -117 -130
-29 -370 -32 -447 -5 -143 50 -216 177 -183 319 12 53 76 190 104 225 134 166
210 234 359 319 70 40 23 27 -59 -17z m726 -699 c-8 -5 -19 -10 -25 -10 -5 0
-3 5 5 10 8 5 20 10 25 10 6 0 3 -5 -5 -10z m-100 -44 c0 -2 -9 -6 -20 -9 -11
-3 -18 -1 -14 4 5 9 34 13 34 5z m-63 -32 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6
11 1 17 -2 13 -5z m309 -39 c-25 -19 -41 -19 -24 0 7 8 20 14 28 14 11 0 10
-3 -4 -14z"/>
<path d="M6562 5278 c-20 -20 -14 -30 15 -26 32 4 46 38 16 38 -11 0 -24 -5
-31 -12z"/>
<path d="M6405 5250 c-39 -26 -50 -56 -25 -70 31 -16 50 -12 82 20 29 30 30
32 13 50 -22 25 -32 25 -70 0z"/>
<path d="M5420 5241 c0 -10 7 -24 15 -31 8 -7 13 -16 10 -20 -3 -4 1 -13 8
-18 9 -8 24 -7 52 3 36 13 34 21 -4 16 -7 -2 -10 2 -6 8 4 7 -4 11 -20 11 -15
0 -24 4 -20 10 3 6 -2 10 -11 10 -22 0 -7 16 21 23 13 3 9 5 -12 6 -26 1 -33
-3 -33 -18z"/>
<path d="M6758 5243 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6694 5225 c-10 -8 -28 -15 -39 -16 -17 -1 -18 -2 -2 -6 19 -5 77 17
77 29 0 12 -14 9 -36 -7z"/>
<path d="M5350 5221 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M6762 5202 c-24 -48 -25 -58 -3 -23 12 18 21 37 19 42 -2 4 -9 -4
-16 -19z"/>
<path d="M5308 5203 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5260 5191 c0 -6 -7 -11 -15 -11 -9 0 -15 -9 -15 -22 0 -39 12 -68
27 -68 19 0 76 30 85 45 4 7 19 11 34 9 19 -2 24 1 20 13 -3 8 -6 18 -6 21 0
4 -4 2 -8 -4 -4 -6 -23 -13 -43 -17 -29 -4 -37 -2 -45 16 -10 23 -34 35 -34
18z"/>
<path d="M6900 5162 c-14 -20 -32 -46 -42 -57 -9 -11 -33 -40 -53 -65 -164
-200 -488 -482 -765 -666 -146 -97 -416 -237 -518 -269 -13 -4 -22 -9 -19 -11
7 -8 261 84 384 139 67 30 171 84 232 121 358 214 589 444 784 779 34 58 32
81 -3 29z"/>
<path d="M6585 5170 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"/>
<path d="M5131 5134 c-52 -23 -61 -37 -61 -95 0 -51 0 -51 23 -36 12 9 41 26
63 37 41 20 42 21 33 58 -5 20 -9 40 -9 45 0 10 -9 8 -49 -9z"/>
<path d="M6017 5143 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M6240 5120 c-24 -24 -18 -40 14 -40 33 0 53 25 36 45 -17 20 -26 19
-50 -5z"/>
<path d="M6035 5120 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"/>
<path d="M5505 5106 c-20 -9 -20 -11 -5 -42 8 -18 20 -33 25 -33 6 0 33 11 60
24 52 26 50 33 -4 14 -31 -11 -56 -5 -35 9 20 13 -18 39 -41 28z m24 -27 c-16
-10 -23 -4 -14 10 3 6 11 8 17 5 6 -4 5 -9 -3 -15z"/>
<path d="M5971 5096 c11 -24 12 -24 63 -9 28 8 53 17 55 19 9 8 -27 4 -59 -8
-28 -9 -35 -8 -45 5 -18 25 -26 20 -14 -7z"/>
<path d="M5328 5067 c-31 -12 -59 -25 -63 -28 -7 -8 14 -97 25 -104 5 -3 29 5
53 19 25 13 59 28 76 34 34 12 42 41 16 62 -8 7 -15 19 -15 26 0 19 -24 16
-92 -9z"/>
<path d="M4992 5035 c-12 -20 -25 -56 -29 -82 l-6 -46 36 27 c35 26 37 32 37
82 0 30 -3 54 -7 54 -5 0 -18 -16 -31 -35z"/>
<path d="M5768 5034 c17 -34 40 -48 27 -16 -4 9 -8 22 -8 29 0 6 -8 14 -18 16
-16 4 -16 3 -1 -29z"/>
<path d="M5910 5050 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M5654 5036 c-10 -7 -40 -19 -67 -26 -26 -7 -49 -16 -52 -19 -5 -10
32 -91 42 -90 4 0 34 13 67 28 55 25 57 28 42 44 -10 9 -15 21 -12 26 4 5 0
12 -6 14 -10 4 -9 8 2 16 8 5 12 12 9 15 -3 3 -14 0 -25 -8z"/>
<path d="M5810 5023 c0 -15 16 -17 25 -3 4 6 11 8 16 5 5 -4 16 -2 25 3 12 6
5 9 -25 9 -28 0 -41 -4 -41 -14z"/>
<path d="M5690 5012 c0 -21 26 -60 34 -51 6 6 -21 69 -30 69 -2 0 -4 -8 -4
-18z"/>
<path d="M5142 4987 c-56 -28 -62 -34 -62 -63 0 -17 5 -45 11 -62 l10 -30 70
35 c38 20 69 41 69 47 0 6 -8 32 -18 57 l-17 46 -63 -30z"/>
<path d="M6155 5009 c-4 -6 -4 -13 -1 -16 8 -8 36 5 36 17 0 13 -27 13 -35 -1z"/>
<path d="M5880 4970 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M5435 4951 c-6 -4 -36 -19 -68 -31 -63 -26 -63 -26 -30 -102 l16 -37
81 41 c44 23 82 42 84 43 1 1 -9 23 -24 48 -25 46 -40 56 -59 38z"/>
<path d="M6047 4954 c-9 -10 2 -24 19 -24 8 0 14 7 14 15 0 15 -21 21 -33 9z"/>
<path d="M5820 4940 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M5920 4933 c0 -9 -17 -13 -52 -13 -38 0 -49 -3 -38 -10 10 -7 12 -12
4 -17 -6 -5 -13 -15 -16 -23 -3 -8 -8 2 -12 23 -4 20 -11 37 -16 37 -12 0 -13
-23 -2 -34 4 -4 7 -11 7 -14 3 -31 18 -82 25 -82 9 0 130 70 130 75 0 10 -29
67 -30 58z m1 -56 c-10 -9 -11 -8 -5 6 3 10 9 15 12 12 3 -3 0 -11 -7 -18z"/>
<path d="M5010 4908 c-14 -11 -36 -29 -49 -39 -21 -17 -23 -24 -16 -74 3 -30
11 -55 17 -55 5 0 29 14 53 31 44 31 44 32 38 78 -10 78 -14 83 -43 59z"/>
<path d="M5692 4873 c-7 -18 -11 -22 -11 -10 -1 19 -16 23 -26 7 -3 -5 -16
-10 -28 -10 -48 0 -50 -13 -18 -84 16 -36 35 -66 41 -66 19 0 120 62 120 74 0
18 -51 116 -60 116 -5 0 -13 -12 -18 -27z m38 -37 c0 -12 -5 -7 -19 24 -11 24
-11 24 3 6 9 -11 16 -24 16 -30z"/>
<path d="M5175 4827 c-33 -17 -62 -33 -64 -34 -5 -3 47 -113 54 -113 6 0 125
68 134 76 8 7 -43 104 -54 103 -5 0 -37 -14 -70 -32z"/>
<path d="M5457 4780 c-32 -16 -65 -30 -73 -32 -11 -2 -5 -16 22 -58 20 -30 40
-59 44 -63 5 -5 39 6 78 23 l70 33 -18 31 c-46 82 -55 96 -60 95 -3 0 -31 -13
-63 -29z"/>
<path d="M5019 4734 c-19 -14 -40 -29 -48 -34 -12 -6 -10 -17 14 -64 15 -31
30 -56 32 -56 2 0 21 13 44 29 22 17 46 32 52 34 13 4 -36 117 -51 117 -4 0
-24 -12 -43 -26z"/>
<path d="M5257 4683 l-68 -34 20 -27 c11 -15 29 -37 39 -50 l18 -23 65 22 c35
12 67 25 72 28 5 6 -59 104 -75 115 -2 2 -34 -13 -71 -31z"/>
<path d="M5740 4640 c-8 -5 -12 -11 -10 -14 3 -2 14 2 24 10 22 15 10 19 -14
4z"/>
<path d="M5850 4530 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M6295 4340 c-16 -11 -25 -20 -19 -20 11 0 64 39 54 40 -3 0 -18 -9
-35 -20z"/>
<path d="M6209 4282 c-13 -10 -39 -25 -56 -33 -18 -8 -33 -17 -33 -21 0 -5 -5
-8 -11 -8 -6 0 -57 -22 -112 -50 -247 -120 -588 -214 -872 -240 -66 -6 -176
-18 -244 -27 l-124 -17 39 -13 c91 -32 309 -73 444 -84 318 -27 670 47 911
189 88 52 249 195 235 209 -4 4 -15 -3 -25 -16 l-18 -23 5 31 c2 19 0 31 -7
31 -6 0 -11 -10 -11 -22 -1 -22 -1 -22 -12 -3 -6 11 -19 27 -28 35 -9 8 -14
23 -12 33 3 15 -2 18 -25 15 -16 -2 -27 -8 -25 -15 1 -7 -7 -13 -18 -13 -28 0
-25 18 5 32 14 6 25 15 25 20 0 12 -4 10 -31 -10z m-49 -62 c0 -5 -5 -10 -11
-10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m167 -80 c3 -10 2 -11 -4
-4 -4 6 -15 14 -23 17 -11 5 -9 6 4 4 11 -1 21 -9 23 -17z m-38 -27 c-7 -10
-15 -20 -16 -22 -2 -2 -3 5 -3 17 0 14 6 22 16 22 14 0 15 -3 3 -17z m-35 -29
c3 -8 2 -12 -4 -9 -6 3 -10 10 -10 16 0 14 7 11 14 -7z"/>
<path d="M6406 4203 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M2835 3161 c-45 -11 -70 -27 -99 -62 -21 -24 -26 -41 -26 -83 0 -88
38 -122 178 -155 44 -10 89 -24 100 -30 32 -17 38 -50 13 -75 -30 -29 -136
-28 -205 2 -27 12 -52 22 -57 22 -8 0 -39 -63 -39 -80 0 -18 109 -53 176 -58
132 -8 228 34 254 114 31 93 -35 165 -175 194 -93 19 -125 37 -125 71 0 55 79
74 181 42 30 -10 58 -17 62 -18 4 0 16 19 27 42 l18 41 -41 17 c-46 19 -194
29 -242 16z"/>
<path d="M4071 3159 c-145 -42 -223 -192 -179 -343 17 -57 99 -138 162 -159
88 -30 228 -17 305 29 l31 18 0 111 0 111 -102 -2 -103 -2 -3 -36 -3 -36 50 0
51 0 0 -45 c0 -40 -3 -47 -27 -56 -42 -16 -125 -14 -160 5 -18 9 -45 33 -60
53 -24 31 -28 46 -28 98 0 49 5 69 25 98 31 45 84 70 146 69 56 -2 80 -9 117
-35 l29 -20 36 37 37 37 -30 25 c-59 48 -203 69 -294 43z"/>
<path d="M6748 3163 c-15 -2 -48 -23 -74 -46 -41 -38 -47 -48 -51 -93 -9 -89
34 -128 177 -164 132 -33 161 -64 103 -110 -25 -20 -36 -21 -93 -16 -35 4 -84
16 -108 27 -25 10 -48 19 -52 19 -4 0 -15 -18 -25 -41 -19 -40 -19 -41 1 -53
73 -43 220 -59 301 -32 95 32 139 103 114 187 -16 53 -63 82 -176 110 -102 25
-131 44 -121 83 10 39 69 53 149 37 34 -7 66 -17 72 -22 18 -18 31 -8 47 35
l16 43 -36 18 c-37 18 -185 29 -244 18z"/>
<path d="M3200 2905 l1 -255 59 0 59 0 3 145 3 146 75 -120 c70 -113 77 -121
104 -118 27 2 38 15 105 129 l76 127 3 -155 3 -155 57 3 57 3 -1 250 -2 250
-52 0 -53 0 -49 -80 c-27 -44 -69 -115 -94 -158 l-46 -77 -37 57 c-20 32 -50
80 -66 107 -17 27 -38 60 -47 75 -10 14 -24 38 -33 54 -14 24 -21 27 -71 27
l-55 0 1 -255z"/>
<path d="M7102 2978 c3 -154 6 -189 22 -218 47 -89 96 -115 221 -115 122 0
174 29 216 120 16 34 19 66 19 218 l0 177 -59 0 -60 0 -3 -181 -3 -181 -33
-29 c-62 -56 -170 -29 -191 48 -6 21 -11 107 -11 191 l0 152 -61 0 -61 0 4
-182z"/>
<path d="M7660 2905 l0 -255 161 0 c181 0 240 11 284 52 27 25 30 34 30 89 0
59 -2 63 -38 95 l-39 33 22 23 c12 13 26 34 31 48 14 34 2 94 -24 118 -47 44
-87 52 -262 52 l-165 0 0 -255z m318 149 c22 -15 29 -48 14 -71 -13 -21 -62
-33 -138 -33 l-74 0 0 60 0 60 88 0 c63 0 94 -4 110 -16z m23 -210 c26 -24 25
-69 -3 -88 -17 -12 -48 -16 -120 -16 l-98 0 0 66 0 67 101 -6 c76 -4 105 -9
120 -23z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
